module.exports = __webpack_public_path__ + "static/media/linkIcon.6735f0a3.png";